import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import CommonAddContact from '../common/CommonAddContact';
import APIService from '../../../Services/APIService';

export default function BasicDetailsSalon() {
  const { id } = useParams();
  const [vendors, setVendors] = useState();
  const [details, setDetails] = useState();
  const [formData, setFormData] = useState();
  const initialContactForm = {
    contact_type: '',
    country_code: '',
    email: '',
    landline: null,
    mobile: null,
    name: '',
    object_id: '',
    salutation: '',
    std_code: '',
  };

  const getOrganizations = async () => {
    let res = await APIService.get(ANG_APIS.GET_ORGANIZATIONS);
    if (res.status == 200) setVendors(res.data);
  };

  const getDetails = async () => {
    let res = await APIService.get(`${ANG_APIS.GET_LIST_GENERIC}${id}/?supplier_type_code=SA`);
    if (res.status == 200) {
      setDetails(res.data);
      setFormData(res.data);
    };
  };

  useEffect(() => {
    getOrganizations();
    getDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;
    setFormData(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res = await APIService.put(`${ANG_APIS.GET_LIST_GENERIC}${id}`, formData);
    if (res) alert('Done');
  };

  const handleAddContact = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contactData: [...prevFormData.contactData, initialContactForm],
    }));
  };

  return (
    <>
      <div className="panel-default panel-container">
        <label style={{ color: '#3c763d' }}>Representative :</label>
        <select
          className="form-control"
          ng-model="representativeField.name"
          ng-change="setVendor()"
        >
          <option value="" disabled>
            Select Representative/Principal Vendor
          </option>
          {vendors &&
            vendors.map((vendor, key) => {
              return (
                <option key={key} value={vendor.name} ng-repeat="vendor in vendorData">
                  {vendor.name}
                </option>
              );
            })}
        </select>
        <br />
        <form className="form-inline" role="form" name="Salon_form" onSubmit={handleSubmit}>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="supplier_id">Corporate ID</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="supplier_id"
              ng-model="corporateId"
              placeholder="Corporate ID"
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="supplier_name">Name</label>
            <br />
            <input
              type="text"
              disabled
              className="form-control"
              id="supplier_id"
              value={details?.name}
              placeholder="Name"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="address1">
              Address1<sup>*</sup>
            </label>
            <br />
            <input
              type="text"
              className="form-control"
              id="address1"
              value={details?.master_data.address_supplier.address1}
              placeholder="Address1"
              required
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="address2">Address2</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="address2"
              value={details?.master_data.address_supplier.address2}
              placeholder="Address2"
            />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="locality">Locality</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="locality"
              value={details?.master_data.address_supplier.area}
              placeholder="Locality"
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="locality">Sub Area</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="subarea"
              value={details?.master_data.address_supplier.subarea}
              placeholder="Sub Area"
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="city">City</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="city"
              value={details?.master_data.address_supplier.city}
              disabled
              placeholder="City"
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="state">State</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="state"
              value={details?.master_data.address_supplier.state}
              placeholder="State"
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="zipcode">Zip Code</label>
            <br />
            <input
              type="number"
              name="zip_code"
              className="form-control"
              id="zipcode"
              value={details?.master_data.address_supplier.zipcode}
              ng-pattern="/^[0-9]{6}$/"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
              placeholder="Zip Code"
            />
            <div
              ng-show="corporate_form.zip_code.$error.pattern"
              className="error"
              style={{ fontSize: '12px' }}
            >
              Please enter 6 digit positive numbers only
            </div>
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="latitude">Latitude</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="latitude"
              value={details?.master_data.address_supplier.latitude}
              placeholder="Latitude"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="longitude">Longitude</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="longitude"
              value={details?.master_data.address_supplier.longitude}
              placeholder="Longitude"
            />
          </div>
          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Categorization</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>
              Salon Type<sup>*</sup>
            </label>
            <br />

            <select className="form-control" ng-model="model.Salon_type" required>
              <option value="" disabled>
                Select Salon Type
              </option>
              <option ng-repeat="Salon_type in Salontypelist" value="{{Salon_type}}">
                {/* {{ Salon_type }} */}
              </option>
            </select>
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Chain/Individual</label>
            <br />
            <select className="form-control" ng-model="model.Salon_type_chain">
              <option value="" disabled>
                Select Chain/Individual{' '}
              </option>
              <option ng-repeat="item1 in chainlist" value="{{item1}}">
                {/* {{ item1 }} */}
              </option>
            </select>
          </div>

          <div className="form-group" style={{ marginBottom: '20px' }}>
            <label for="origin">Chain Origin</label>
            <br />
            <input
              type="text"
              placeholder="Chain Origin"
              className="form-control"
              id="origin"
              ng-model="model.chain_origin"
            />
          </div>

          <br />
          <br />
          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Counts and Ratings</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="footfall_day">Weekday Daily Footfall Count</label>
            <br />
            <input
              type="number"
              className="form-control"
              placeholder="Weekday Daily Footfall Count"
              id="footfall_day"
              ng-model="model.master_data.unit_secondary_count"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="footfall_weekend">Weekend Daily Footfall Count</label>
            <br />
            <input
              type="number"
              className="form-control"
              placeholder="Weekend Daily Footfall Count"
              id="footfall_weekend"
              ng-model="model.master_data.unit_primary_count"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="membership_count">Membership Count</label>
            <br />
            <input
              type="number"
              className="form-control"
              id="membership_count"
              placeholder="Membership Count"
              ng-model="model.master_data.unit_tertiary_count"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Salon Rating</label>
            <br />
            <select className="form-control" ng-model="model.category">
              <option value="" disabled>
                Select Salon Rating{' '}
              </option>
              <option ng-repeat="cat in categorylist" value="{{cat}}">
                {/* {{ cat }} */}
              </option>
            </select>
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Locality Rating</label>
            <br />
            <select className="form-control" ng-model="model.locality_rating">
              <option value="" disabled>
                Select Locality Rating{' '}
              </option>
              <option ng-repeat="lrating in localityratinglist" value="{{lrating}}">
                {/* {{ lrating }} */}
              </option>
            </select>
          </div>
          <div className="form-group " style={{ marginBottom: '20px' }}>
            <label for="area">Machadalo Index</label>
            <br />
            <input
              type="number"
              placeholder="Machadalo Index"
              className="form-control"
              id="mdindex"
              ng-model="model.machadalo_index"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
              disabled
            />
          </div>

          <br />
          <br />
          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Other Details</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Current Advertising Media</label>
            <br />
            <input
              type="text"
              placeholder="Current Advertising Media"
              className="form-control"
              ng-model="model.advertising_media"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Diet Chart/Workout Planner(6 months)</label>
            <br />
            <input
              type="number"
              placeholder="Diet Chart"
              className="form-control"
              ng-model="model.dietchart_price"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group " style={{ marginBottom: '20px' }}>
            <label for="membership">Total Membership/Annum</label>
            <br />
            <input
              type="number"
              placeholder="Total Membership/Annum"
              className="form-control"
              id="membership"
              ng-model="model.totalmembership_perannum"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>

          <br />
          <br />

          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Payment Details</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Salon Name</label>
            <br />
            <input
              type="text"
              placeholder="Salon Name"
              className="form-control"
              ng-model="ownership_details.bank_account_name"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Bank Name</label>
            <br />
            <input
              type="text"
              placeholder="Bank Name"
              className="form-control"
              ng-model="ownership_details.bank_name"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>IFSC Code</label>
            <br />
            <input
              type="text"
              placeholder="IFSC Code"
              className="form-control"
              ng-model="ownership_details.ifsc_code"
            />
          </div>
          <div className="form-group " style={{ marginBottom: '20px' }}>
            <label>Account Number</label>
            <br />
            <input
              type="text"
              placeholder="Account Number"
              className="form-control"
              ng-model="ownership_details.account_number"
            />
          </div>

          <h2 className="heading">Contact Details</h2>
          <div className="col-md-12" style={{ marginLeft: -'15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Contact Details</h3>
            </label>
            <br />
          </div>
          <CommonAddContact formData={formData} setFormData={setFormData} />
          <input
            onClick={handleAddContact}
            type="button"
            className="smallBtn"
            value="Add"
            ng-click="addNewContact()"
          />
          <br />
          <br />
          <div className="bottomButtonBox">
            <button type="submit" className="smallBtn">
              Update Salon
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
